// extracted by mini-css-extract-plugin
export default {"IssuerMyQuotes":"issuerMyQuotes_IssuerMyQuotes__0HaBm","IssuerMyQuotesContent":"issuerMyQuotes_IssuerMyQuotesContent__UHhEy"};